import firebase from "firebase/app";
import "firebase/auth";

import config from "../../config.public";

export default async () => {
    const provider = new firebase.auth.SAMLAuthProvider(config.gcf.prod.rippling);
    firebase.auth().signInWithPopup(provider);
};
